import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import { BulkFulfillmentPlanTagDropdownContent } from './bulk-tag-dropdown-content';
import { SAVE_TAGS_BUTTON_ID } from './tag-context';

import messages from '../../../../components/tag-dropdown/messages';

export const BulkFulfillmentPlanTagDropdown = ({
  dropdownMenuClassName,
  dropdownMenuTogglerClass,
  dropdownTogglerContentClassName,
  className,
}) => {
  const shouldAllowDropdownToClose = (e) => {
    if (e.target.id === SAVE_TAGS_BUTTON_ID) {
      return true;
    }
    return false;
  };
  return (
    <DropdownMenu
      className={className}
      closeWhenChildrenClicked={false}
      containerAllowedMeToClose={shouldAllowDropdownToClose}
      dropdownMenuClassName={dropdownMenuClassName}
      dropdownMenuShouldHaveWidthOfButton={false}
      dropdownMenuType={DropdownMenuType.menu}
      menuPosition='bottom-left'
    >
      <DropdownMenuToggler
        className={dropdownMenuTogglerClass}
        dropdownTogglerContentClassName={dropdownTogglerContentClassName}
        theme='link'
      >
        <FormattedMessage {...messages.addTag} />
      </DropdownMenuToggler>
      <BulkFulfillmentPlanTagDropdownContent />
    </DropdownMenu>
  );
};

BulkFulfillmentPlanTagDropdown.propTypes = {
  className: PropTypes.string,
  dropdownMenuTogglerClass: PropTypes.string,
  dropdownMenuClassName: PropTypes.string,
  dropdownTogglerContentClassName: PropTypes.string,
};
